document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('[data-em-slider]').forEach(function(shell){
    var track=shell.querySelector('[data-em-track]');
    if(!track)return;
    shell.querySelectorAll('[data-em-direction]').forEach(function(button){
      button.addEventListener('click',function(){
        var direction=button.getAttribute('data-em-direction')==='next'?1:-1;
        track.scrollBy({left:direction*track.clientWidth*.88,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      });
    });
  });
});
